import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow",
  "use": "arrow-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"arrow\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.66 11.52 14.15 6l-.81.8 5.15 5.16-.1.04.1.04-5.3 5.3.82.8 5.94-5.93.2-.21-.48-.48Z\" fill=\"currentColor\" /><path d=\"M19.05 11.4H4.19v1.14h14.86V11.4Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol